<template>
  <div >
    <el-tabs v-model="country" @tab-click="handleClick">
      <el-tab-pane label="美国" name="1"></el-tab-pane>
      <el-tab-pane label="加拿大" name="2"></el-tab-pane>
    </el-tabs>
    <keep-alive>
        <components
            :is="currentComponent"
            :country="country">
        </components>
    </keep-alive>
  </div>
</template>

<script>
import countryView from '@v/removalMgmt/RemovalReportMgmt.vue'
export default {
    data () {
        return {
            country: '1',
            currentComponent: 'countryView1',
            componentList: [
                'countryView1',
                'countryView2'
            ]
        }
    },
    components: {
        countryView1: countryView,
        countryView2: countryView
    },
    methods: {
        handleClick () {
            console.log(this);
            this.currentComponent = this.componentList[this.country - 0 - 1];
        }
    }
}
</script>

<style>
  .el-tabs__nav-scroll{
    padding-left: 15px;
  }
</style>
